module.exports = __webpack_public_path__ + "static/media/icon-validated.0384f0ed.svg";